import { Button } from 'antd';
import classnames from 'classnames';
import React from 'react';
import './styles.scss';

const MyButton = ({ className, children, ...rest }) => {
  return (
    <Button className={classnames('site-button', className)} {...rest}>
      {children}
    </Button>
  );
};

MyButton.propTypes = {};

export default MyButton;
